export default __webpack_public_path__ + "static/media/icn-info.cbc9c156.svg";